import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { SummaryBrand } from "src/types/graphql.d";
import { formatName } from "src/utils/formatName";
import { ApolloError } from "@apollo/client";

const POPULAR_BRANDS = gql`
  query popularBrands($category: String!) {
    popularBrands(category: $category) {
      id
      name
      image
      sales_landing
      slug
      logo
      overlay_logo
      logo_svg
      discount
      gate {
        level
      }
      user_wishlist_item_id
      labels {
        type
        value
        priority
        color
        text_color
        background_color
      }
    }
  }
`;

interface popularBrandsVarsData {
  popularBrands: SummaryBrand[];
}

interface popularBrandsVars {
  category: string;
}

interface PopularBrandsData {
  data: undefined | SummaryBrand[];
  loading: boolean;
  error: ApolloError | undefined;
}

const usePopularBrands = (
  category: string,
  excludeSlug?: string
): PopularBrandsData => {
  const { loading, error, data } = useQuery<
    popularBrandsVarsData,
    popularBrandsVars
  >(POPULAR_BRANDS, {
    variables: { category },
    ssr: false,
    fetchPolicy: "cache-and-network",
  });
  // Exclude the current brandId from results
  // and format brand name
  const transformData =
    data &&
    data?.popularBrands
      ?.filter((brand) => brand.slug !== excludeSlug)
      .map((brand) => ({ ...brand, name: formatName(brand.name) }));
  return { loading, error, data: transformData };
};

export { usePopularBrands };
